/**
 * 获取url指定参数的值
 * @param key url参数名
 * @param url url，默认为当前页面url
 */
export function getUrlParam(name: string, url = window.location.href) {
  const urlSearchParams = new URL(url).searchParams;
  return urlSearchParams.get(name);
}

/**
 * url添加参数
 * @param url url
 * @param name 参数名
 * @param value 参数值
 */
export function addUrlParam(url: string, name: string, value: any) {
  return addUrlParams(url, { [name]: value });
}

/**
 * url添加多个参数
 * @param url url
 * @param params 参数
 */
export function addUrlParams(url: string, params: Record<string, any>) {
  const urlObject = new URL(url);
  Object.keys(params).forEach((name) => {
    const value = params[name];
    if (urlObject.searchParams.has(name)) {
      urlObject.searchParams.delete(name);
    }
    urlObject.searchParams.append(name, value as string);
  });
  return urlObject.href;
}

/**
 * 去除URL中指定的参数
 * @param url url
 * @param name 参数名
 */
export function removeUrlParam(url: string, name: string) {
  return removeUrlParams(url, [name]);
}

/**
 * 去除URL中指定的参数
 * @param url url
 * @param params 参数列表
 */
export function removeUrlParams(url: string, params: string[]) {
  const urlObject = new URL(url);
  params.forEach((name) => {
    if (urlObject.searchParams.has(name)) {
      urlObject.searchParams.delete(name);
    }
  });
  return urlObject.href;
}

/**
 * url search params参数转化为Object
 * @param params url search params格式的字符串
 */
export function paramsToObject<T extends object = {}>(params: string) {
  const searchParams = new URLSearchParams(params);
  const result = {};
  for (const [key, value] of searchParams.entries()) {
    result[key] = value;
  }
  return result as T;
}

/**
 * Object转换为url search params数据
 * @param object Object类型数据
 */
export function objectToParams(object: object) {
  const searchParams = new URLSearchParams();
  Object.keys(object).forEach((name) => {
    searchParams.append(name, object[name]);
  });
  return searchParams.toString();
}
